export default __webpack_public_path__ + "static/media/Start creating a PDF Journal.6b51bbee.mp4";